export const clusterNameAnnotation = {
    text:
        'クラスタ名は、クラスタ内のIPCのラベルに基づいて生成AIによる命名が実施されており、クラスタの技術情報の正確な要約を保証するものではありません。'
}
